export default __webpack_public_path__ + "static/media/330_store03-it-mobile.6021a5b1.png";